import { useState } from "react";
import { Plus, Trash, Broadcast } from "@phosphor-icons/react";
import { Button } from "@/components/ui/button";
import CreateChannelDialog from "@/components/studio/CreateChannelDialog";
import { LANGUAGES } from "@/lib/api";

const langCode = (c) => LANGUAGES.find((l) => l.code === c)?.code?.toUpperCase() || c.toUpperCase();

export const ChannelSidebar = ({
  channels,
  selectedId,
  onSelect,
  onCreate,
  onDelete,
}) => {
  const [open, setOpen] = useState(false);

  return (
    <aside className="h-full flex flex-col" data-testid="channel-sidebar">
      <div className="p-4 border-b border-border/60">
        <div className="flex items-center justify-between mb-3">
          <span className="label-mono text-muted-foreground">Channels</span>
          <span className="label-mono text-muted-foreground">
            {String(channels.length).padStart(2, "0")} / ∞
          </span>
        </div>
        <Button
          data-testid="create-channel-btn"
          onClick={() => setOpen(true)}
          className="w-full h-11 rounded-none bg-primary hover:bg-[#D63028] text-white font-bold uppercase tracking-wider text-xs transition-colors"
        >
          <Plus size={16} weight="bold" className="mr-2" />
          Yeni Kanal Oluştur
        </Button>
      </div>
      <div className="flex-1 overflow-y-auto" data-testid="channel-list">
        {channels.length === 0 && (
          <div className="p-8 text-center">
            <div className="w-14 h-14 mx-auto mb-4 border border-border flex items-center justify-center">
              <Broadcast size={22} color="#737373" />
            </div>
            <p className="label-mono text-muted-foreground mb-2">Boş liste</p>
            <p className="text-sm text-muted-foreground">
              İlk YouTube kanalını oluşturarak başla.
            </p>
          </div>
        )}
        <ul>
          {channels.map((c) => {
            const active = c.id === selectedId;
            return (
              <li
                key={c.id}
                data-testid={`channel-item-${c.id}`}
                onClick={() => onSelect(c.id)}
                className={`group relative cursor-pointer px-5 py-4 border-b border-border/40 hover:bg-[#141414] transition-colors ${
                  active ? "bg-[#151515]" : ""
                }`}
              >
                <span
                  className={`absolute left-0 top-0 bottom-0 w-[3px] ${
                    active ? "bg-primary" : "bg-transparent group-hover:bg-border"
                  }`}
                />
                <div className="flex items-start justify-between gap-2">
                  <div className="min-w-0 flex-1">
                    <p className="heading-font font-bold text-[15px] tracking-tight truncate">
                      {c.name}
                    </p>
                    <div className="flex items-center gap-2 mt-1.5">
                      <span className="label-mono border border-border px-1.5 py-0.5 text-muted-foreground">
                        {langCode(c.language)}
                      </span>
                      <span className="label-mono text-muted-foreground truncate">
                        {c.category}
                      </span>
                    </div>
                  </div>
                  <button
                    data-testid={`delete-channel-${c.id}`}
                    onClick={(e) => {
                      e.stopPropagation();
                      if (window.confirm(`"${c.name}" silinsin mi?`)) onDelete(c.id);
                    }}
                    className="opacity-0 group-hover:opacity-100 h-7 w-7 flex items-center justify-center border border-border hover:border-primary hover:text-primary text-muted-foreground transition-colors"
                    aria-label="delete channel"
                  >
                    <Trash size={13} />
                  </button>
                </div>
              </li>
            );
          })}
        </ul>
      </div>
      <CreateChannelDialog open={open} onOpenChange={setOpen} onSubmit={onCreate} />
    </aside>
  );
};

export default ChannelSidebar;
